import {useState, useEffect, RefObject} from 'react'

/**
 * @name useIsElementInViewport
 *
 * @description
 * Custom hook that detects if the element is visible in the viewport
 *
 * @hook
 * @param {RefObject<HTMLElement>} ref - The ref for the element to be observed
 * @returns {boolean} A boolean value indicating whether the element is visible in the viewport
 *
 */

const useIsElementInViewport = (ref: RefObject<HTMLElement>) => {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const options = {
            threshold: [0],
        }

        const observerCallback = ([entry]: IntersectionObserverEntry[]) => {
            setIsVisible(entry.isIntersecting)
        }

        const observer = new IntersectionObserver(observerCallback, options)

        if (ref.current) {
            observer.observe(ref.current)
        }

        return () => {
            observer.disconnect()
        }
    }, [ref])

    return isVisible
}

export {useIsElementInViewport}
